import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MarcheNegocie } from '../models/MarcheNegocie';
@Component({
  selector: 'app-marche-negocie',
  templateUrl: './marche-negocie.component.html'
})
export class MarcheNegocieComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'MarcheNegocie'
  @Input() parentForm: FormGroup;
  	@Input() marcheNegocie : MarcheNegocie;

  constructor() { }

  public ngOnInit() {
  }








  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }


}

